import React, { Component } from 'react';
import './Header.scss';

export default class Header extends Component {
  componentDidMount() {
    //console.log('header init');
    $(window).scroll(function() {
      if ($(window).scrollTop() >= 100) {
        $('header').addClass('fixed-header');
      } else {
        $('header').removeClass('fixed-header');
      }
    });

    $(".lets-talk").click(function() {
      $('html,body').animate({
          scrollTop: $("#contact").offset().top},
          'slow');
    });

    // hide loader
    document.getElementById("loading").style.display = "none";

    // http://davist11.github.io/jQuery-One-Page-Nav/
    $('.header .navbar').onePageNav({
      currentClass: 'current',
      changeHash: false,
      scrollSpeed: 750
    });
  }

  render() {
    return (
      <header className="header">
        <nav className="navbar">
          <div className="container">
            <div className="navbar-header">

              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>

              <h1 className="logo">
                <a href="https://wired247.github.io">David Willoughby</a>
              </h1>
            </div>

            <div id="navbar" className="collapse navbar-collapse">
              <ul className="nav navbar-nav navbar-right">
                <li className="current"><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#expertise">Expertise</a></li>
                <li><a href="#recent-work">Recent Work</a></li>
                <li><a href="#resume">Experience</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

          </div>
        </nav>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Header.js